import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';

import { MtnaSearchBoxModule } from '@mtna/lib-ui';

import { RdsVariableSelectionDialogComponent } from './variable-selection-dialog.component';

const COMPONENTS = [RdsVariableSelectionDialogComponent];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatListModule,
    MatPaginatorModule,
    MatRadioModule,
    MtnaSearchBoxModule,
    ScrollingModule
  ],
  exports: COMPONENTS,
  declarations: COMPONENTS,
  entryComponents: COMPONENTS
})
export class RdsVariableSelectionDialogModule {}

export * from './variable-selection-dialog.component';
